import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'  // 🚀 Force instant scroll
    });
  }, [pathname]);

  return children || null;
};

export default ScrollTop;
